module.exports = function() {
  return new Worker(__webpack_public_path__ + "3b9890db11f865124fef.worker.js");
};